import { useContext, useEffect, useState } from 'react';
import { Navigate } from 'react-router';
import { FirebaseContext } from '@/session/FirebaseContext';
import { AuthLoadingScreen } from '@/components/AuthCards/auth-ui';

export default function SignOutPage() {
  const { auth } = useContext(FirebaseContext);
  const [signedOut, setSignedOut] = useState(false);

  useEffect(() => {
    void auth.signOut().then(() => setSignedOut(true));
  }, [auth]);

  if (!signedOut) {
    return <AuthLoadingScreen message='Signing out…' />;
  }

  return <Navigate replace to='/' />;
}
